import { Coins } from "lucide-react";
import { dictionary } from "../../../utils/dictionary";
import { useAuth } from "../../../context/AuthContext";
import { IconCredit } from "../../../assets/icons/icons";

interface CreditsBadgeProps {
  amount: number;
  label?: string;
  className?: string;
}

export function CreditsBadge({ amount, label, className }: CreditsBadgeProps) {
  const { language } = useAuth();

  return (
    <div className={`flex items-center rounded-full px-3 py-1 ${className || ""}`}>
      <span className="text-base font-semibold text-gray-900 mr-2">
        {label || dictionary["credits"][language]}:
      </span>
      <IconCredit className="text-[#4F46E5] mx-1" />
      <span className="text-xl font-bold text-[#4F46E5]">{amount}</span>
    </div>
  );
}